import { render, staticRenderFns } from "./AccountProfilePlans.vue?vue&type=template&id=63937c66&"
import script from "./AccountProfilePlans.vue?vue&type=script&lang=js&"
export * from "./AccountProfilePlans.vue?vue&type=script&lang=js&"
import style0 from "./AccountProfilePlans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports